<template>
    <div
        v-show="show"
        class="kgr-region kgr-region--default"
    >
        <h3 class="kgr-headline kgr-headline--h3">
            {{ $t('Rechnungsexport') }}
        </h3>
        <div class="kgr-row">
            {{ $t('Anzahl Rechnungen') }}: <span class="kgr-text kgr-text--bold">{{ invoiceCount }}</span><br />
        </div>
        <br />
        <div>
            <kgr-loader v-if="pendingExport" />
            <div v-else>
                <button
                    class="kgr-button kgr-button--accent kgr-button--small kgr-button--wide"
                    @click="csvExport"
                >
                    {{ $t('CSV-Export') }}
                </button>
                <button
                    class="kgr-button kgr-button--accent kgr-button--small kgr-button--wide"
                    @click="excelExport"
                >
                    {{ $t('Excel-Export') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ClubInvoiceExportRepository from '../../../js/repository/ClubInvoiceExportRepository.js';
import Loading from '../../../components/common/Loading.vue';

export default {
    components: {
        'kgr-loader': Loading,
    },
    props: {
        clubId: {
            type: Number,
            required: false,
            default: null,
        },
        memberId: {
            type: Number,
            required: false,
            default: null,
        },
        query: {
            type: String,
            required: true,
        },
        invoiceCount: {
            type: Number,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            pendingExport: false,
        }
    },
    computed: {
        buttonDisabled() {
            return this.pendingExport || this.invoiceCount === 0;
        },
    },
    methods: {
        csvExport() {
            this.pendingExport = true;
            if (this.clubId) {
                ClubInvoiceExportRepository.getCsvByClubIdAndQuery(this.clubId, this.query)
                    .then(() => {})
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.pendingExport = false);
            } else if (this.memberId) {
                ClubInvoiceExportRepository.getCsvByMemberIdAndQuery(this.memberId, this.query)
                    .then(() => {})
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.pendingExport = false);
            }
        },
        excelExport() {
            this.pendingExport = true;
            if (this.clubId) {
                ClubInvoiceExportRepository.getXlsxByClubIdAndQuery(this.clubId, this.query)
                    .then(() => {})
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.pendingExport = false);
            } else if (this.memberId) {
                ClubInvoiceExportRepository.getXlsxByMemberIdAndQuery(this.memberId, this.query)
                    .then(() => {})
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.pendingExport = false);
            }
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
